/**
 * SKU编辑页面 Hooks - 数据加载
 */

import { useState, useCallback } from 'react';
import { App } from 'antd';
import type { FormInstance } from 'antd';
import { skuAPI } from '../../../services/api';
import * as brandService from '../../../services/brandService';
import type { SKU } from '../../../types/core-types';
import type { BrandSimple } from '../../../services/brandService';

export const useSKUEditData = (id: string | undefined, form: FormInstance) => {
    const { message } = App.useApp();
    const [loading, setLoading] = useState(true);
    const [sku, setSku] = useState<SKU | null>(null);
    const [brands, setBrands] = useState<BrandSimple[]>([]);
    const [brandMode, setBrandMode] = useState<'select' | 'custom'>('select');

    // 加载 SKU 数据
    const loadSKU = useCallback(async () => {
        if (!id) return;

        try {
            setLoading(true);
            const data = await skuAPI.getById(Number(id));
            setSku(data);

            // 设置品牌模式
            if (data.brand_obj) {
                setBrandMode('select');
            } else if (data.brand) {
                setBrandMode('custom');
            }

            // 设置表单值
            // 如果利润率为空且价格也为空，设置默认利润率为 30%
            const formData = { ...data };
            if ((formData.profit_margin === null || formData.profit_margin === undefined) &&
                (formData.price === null || formData.price === undefined)) {
                formData.profit_margin = 30; // 默认 30%
            }
            form.setFieldsValue(formData);
        } catch (error) {
            message.error('加载SKU失败');
            console.error('加载SKU失败:', error);
        } finally {
            setLoading(false);
        }
    }, [id, form, message]);

    // 加载品牌列表
    const loadBrands = useCallback(async () => {
        try {
            const data = await brandService.getSimpleBrands();
            setBrands(data);
        } catch (error) {
            console.error('加载品牌列表失败:', error);
        }
    }, []);

    return {
        loading,
        sku,
        brands,
        brandMode,
        setBrandMode,
        loadSKU,
        loadBrands,
    };
};
